import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import "../style/Navbar.css";
import iitmLogo from "../resources/iitm_logo.png";

function Navbar({ onNavigate }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuItems = [
    "Home",
    "About",
    "Committee",
    "Call for Papers",
    "Registration",
    "Contact Us",
  ];

  const handleNavigation = (item) => {
    const page = item.toLowerCase();
    if (page === "about") {
      onNavigate("about");
    } else if (page === "committee") {
      onNavigate("committee");
    } else if (page === "speakers") {
      onNavigate("speakers");
    } else if (page === "call for papers") {
      onNavigate("call-for-papers");
    } else if (page === "registration") {
      onNavigate("registration");
    } else if (page === "contact us") {
      onNavigate("contact-us");
    } else {
      onNavigate("home");
    }
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="logo">
          <img src={iitmLogo} alt="IITM Logo" />
        </div>

        <button
          className="menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        <ul className={`nav-links ${isMenuOpen ? "active" : ""}`}>
          {menuItems.map((item, index) => (
            <li key={index}>
              <a
                href={
                  item.toLowerCase() === "about"
                    ? "/about"
                    : `#${item.toLowerCase().replace(/\s+/g, "-")}`
                }
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation(item);
                }}
              >
                {item}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div className="ticker">
        <div className="ticker-track">
          <div className="ticker-item">
            <span className="ticker-title">
              IITM College of Engineering - International Conference on Emerging Trends and
              Innovations in Engineering, Management, and Technology
            </span>
            <span className="ticker-dates">
              Friday, 24th April, 2026 | Saturday, 25th April, 2026
            </span>
          </div>
          <div className="ticker-item" aria-hidden="true">
            <span className="ticker-title">
              IITM College of Engineering - International Conference on Emerging Trends and
              Innovations in Engineering, Management, and Technology
            </span>
            <span className="ticker-dates">
              Friday, 24th April, 2026 | Saturday, 25th April, 2026
            </span>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
